import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FacilitySummary } from 'src/app/@core/domain/interfaces/facility-summary.interface';
import { StatusPageService } from '../../../services/status-page.service';

@Component({
  selector: 'app-facility',
  templateUrl: './facility.component.html',
  styleUrls: ['./facility.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacilityComponent {
  @Input()
  facilitySummary!: FacilitySummary;

  @Input()
  statusType!: string;

  @Input()
  alertClass = 'custom-icon__facility';

  constructor(private router: Router, private statusPageService: StatusPageService) {}

  public gotoFacilityDetails(id: number): void {
    this.router.navigate(['/status/facilities/', id], { skipLocationChange: true });
  }

  notificationCounts() {
    return this.statusPageService.formatNotificationTooltip(this.facilitySummary, this.statusType);
  }
}
